import axios from 'axios';

import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';




const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export const svLoadAddressallBegin = () => dispatch => {
    dispatch({
        type:'GET_ADDRESSALL_BEGIN'
        
    })
}


export const geLoadAddressallSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_ADDRESSALL_SUCCESS',
        payload: data
    })
}

export const getLoadAddressallError = (e) =>dispatch => {
    dispatch({
        type:'GET_ADDRESSALL_ERROR',
        payload:e
    })
}



export function deleteAddress_dbworkingsv(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDelete`
        const bodyDelete = {
            "id": (nameQParam? nameQParam:3)
           }

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
        axios.all([
            axios.post(urlDelete, bodyDelete, {headers:headers}),
            axios.post(url,body, {headers:headers})
        ])
        .then(
            axios.spread((rd,r)=>{

                if(rd['status']  == 200){
                  

                   
                    if(r.data.length>0){
                        const ar = r.data
                        const comData = { my_data_addresslist:  ar }
    
                        dispatch(geLoadAddressallSuccess(comData))
                    }
                    else {
                        const comData = { my_data_addresslist: []}
                        dispatch(getLoadAddressallError(comData))
                    }

                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }

            })
        )
        
         /* 
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_addresslist:  ar }

                   
                    dispatch(geLoadAddressallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressallError(e))
        )
        */
    }

}

export function loadAddressListMyReservationForCustId(nameQParam ,custProfile,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)

    console.log(custProfile)
   
    return dispatch => {
        dispatch(svLoadAddressallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlAdminAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const bodyAdminAddressList = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
         const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdView`
       
         const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        let url= null, body=null

        if(custProfile && (custProfile.customerId > 0)){
            console.log('sv*****svaddreslistactiob callss  account/addressListByCustomerIdView')
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
           
            url = urlAddressList
            body = bodyAddressList
           
        }else{
            console.log('sv*****svaddreslistactiob callss  urlAdminAddressList')
            url = urlAdminAddressList
            body = bodyAdminAddressList
           
            console.log('custProfile + error by UI')
        }

        const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :url
        const svhdr = hdr ? hdr: headers 
      

        axios.post(svurl, body, {headers:svhdr})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    ar.map( (o,idx)=>{
                        
                        o['id'] = o['addressId']? o['addressId']: o['id']
                    });
                    const comData = { my_data_addresslist:  ar }

                    //we are lowercase aleadt

                    /*
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data_addresslist.push(sod)
                    });

                   */
                    dispatch(geLoadAddressallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressallError(e))
        )
    }
}




export function loadAddressListMyReservationForCustIdSecure_svbakj16(nameQParam ,custProfile,svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)

    console.log(custProfile)
   
    return dispatch => {
        dispatch(svLoadAddressallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlAdminAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const bodyAdminAddressList = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
         const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdViewSecure`
       
         const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        let url= null, body=null

        if(custProfile && (custProfile.customerId > 0)){
            console.log('sv*****svaddreslistactiob callss  account/addressListByCustomerIdView')
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
            //bodyAddressList.docId.push("" + 56)
           
            url = urlAddressList
            body = bodyAddressList
           
        }else{
            console.log('sv*****svaddreslistactiob callss  urlAdminAddressList')
            url = urlAdminAddressList
            body = bodyAdminAddressList
           
            console.log('custProfile + error by UI')
        }

          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
   
   
        axios.post(url, body, {headers:svheaders})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const ob = r.data

                   
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getLoadAddressallError(eeb))
                    }else{
                        ar.map( (o,idx)=>{
                        
                            o['id'] = o['addressId']? o['addressId']: o['id']
                        });
                        const comData = { my_data_addresslist:  ar }
    
                        //we are lowercase aleadt
    
                        /*
                        var item , ob, sod, upperOb
                        
                        ar.forEach(a_rec => {
                            item = {}
                            upperOb = a_rec
                            ob =lowercaseKeys(upperOb)
                            sod =  _.clone(ob)
    
                            
    
                            comData.my_data_addresslist.push(sod)
                        });
    
                       */
                        dispatch(geLoadAddressallSuccess(comData))
                    }
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressallError(e))
        )
    }
}
export function loadAddressList(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    ar.map( (o,idx)=>{
                        
                        o['id'] = o['addressId']? o['addressId']: o['id']
                    });
                    const comData = { my_data_addresslist:  ar }

                    //we are lowercase aleadt

                    /*
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data_addresslist.push(sod)
                    });

                   */
                    dispatch(geLoadAddressallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressallError(e))
        )
    }
}




export function deleteAddress(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadAddressallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDelete`
        const bodyDelete = {
            "id": (nameQParam? nameQParam:3)
           }

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_addresslist:  ar }

                   
                    dispatch(geLoadAddressallSuccess(comData))
                }
                else {
                    const comData = { my_data_addresslist: []}
                    dispatch(getLoadAddressallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadAddressallError(e))
        )
        
    }

}


export function loadAddressListMyReservationForCustIdSecure(nameQParam ,custProfile,svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)

    console.log(custProfile)
   
    return dispatch => {
        dispatch(svLoadAddressallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlAdminAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const bodyAdminAddressList = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
         const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdViewSecure`
       
         const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        let url= null, body=null
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geographyMyReservation`
         
        const bodyGeoNewList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }

        if(custProfile && (custProfile.customerId > 0)){
            console.log('sv*****svaddreslistactiob callss  account/addressListByCustomerIdView')
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
            //bodyAddressList.docId.push("" + 56)
            /*svj15 start */
            bodyGeoNewList.docId.push("" + customerId)
       
                        
            /*svj15 end*/
           
            url = urlAddressList
            body = bodyAddressList
           
        }else{
            console.log('sv*****svaddreslistactiob callss  urlAdminAddressList')
            url = urlAdminAddressList
            body = bodyAdminAddressList
           
            console.log('custProfile + error by UI')
        }

          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
   //svj15start
   axios.all([
    axios.post(url, body, {headers:svheaders}),
    axios.post(urlGeoList, bodyGeoNewList, {headers:headers}),
], {
    timeout: 7000
})
.then(
    axios.spread((r,r5)=>{
        let my_data_geo = null
        if(r5.data){
             //svr5 start
            
             console.log('svj25 my_data_geo*********')
             console.log(r5.data )
             if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
              my_data_geo = r5.data
             
             }
            
             //svr5 end
        }
        if(r.data.length>0){
            const ar = r.data
            const ob = r.data

           
            if(ob.status && ob.status !=200){
                let eeb = {

                }
                eeb.errob = ob
                dispatch(getLoadAddressallError(eeb))
            }else{
                ar.map( (o,idx)=>{
                
                    o['id'] = o['addressId']? o['addressId']: o['id']
                });
                

                const comData = { my_data_addresslist:  ar , my_data_geo:my_data_geo}

                
                dispatch(geLoadAddressallSuccess(comData))
            }
        }
        else {
            const comData = { my_data_addresslist: [], my_data_geo:my_data_geo}
            dispatch(getLoadAddressallError(comData))
        }
        

    })
    ).catch(
        e=>{
            console.log('errr**REAL******')
            console.log(e)
            dispatch(getLoadAddressallError(e)) }
    )
   //svj15end
   //stae
       
        //end
    }
}